import { component } from 'picoapp';

export default component((node, ctx) => {
  /**
   * Functions
   */
  const update = () => {
    const count = window.Appmate.wk.collection.items[0]?.products.length || 0;
    node.textContent = count > 0 ? count : '';
  };

  const listen = () => {
    window.Appmate.wk.on('render', update);
  };

  const init = () => {
    if (window.Appmate?.wk?.collection) {
      update();
      listen();
    } else {
      window.addEventListener('wishlistKing:loaded', () => {
        update();
        listen();
      });
    }

    ctx.on('wishlist:updated', update);
  };

  /**
   * Init
   */
  init();
});
